import React from 'react';
import { NavLink } from "react-router-dom"; 
import './style.css';

export default function Nav() {
  return (
    <div className="nav">
      <h1><NavLink to="/">Nina Moothedath</NavLink></h1>

      <p><NavLink to="/about">About</NavLink></p>
      <p><NavLink to="/cd">Data Reporting & Graphics</NavLink></p>

      <p><NavLink to="/art_motion">Art & Broadcast Graphics</NavLink></p>
      <p><NavLink to="/va">Multimedia Production</NavLink></p>
    </div> 
  );
}


